<template>
  <div>
    <div class="card">
      <h5 class="card-header">SPSS Excel</h5>
      <div class="card-body">
        <form ref="form" class="needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
          <div class="form-group">
            <button type="submit" class="btn btn-primary mt-3" @click="excelExport" :disabled="isExporting">
              <fa v-if="isExporting" icon="circle-notch" spin />
              <fa v-if="!isExporting" icon="file-excel" />
              <span class="ml-2">Excel Export</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formWasValidated: false,
      isExporting: false,
    };
  },
  methods: {
    excelExport() {
      this.isExporting = true;
      this.$axios
        .post("/v1/admin/spss/excel")
        .then(res => {
          const link = document.createElement("a");
          link.target = "_blank";
          link.rel = "noopener noreferrer";
          link.href = res.data.url;
          link.click();
          link.remove();
        })
        .finally(() => (this.isExporting = false));
    },
  },
};
</script>
